var styles = ["[_ngcontent-%COMP%]:not(button){font-size:.7rem}.divider[_ngcontent-%COMP%]{margin:1rem 0}.backup-client[_ngcontent-%COMP%]{min-height:1rem;color:gray}"];
export { styles as styles };
